(() => {

    const subscribe = (section, payload) => {
        const companyId = (section.dataset.klaviyoCompanyId || "").trim();
        const listId = (section.dataset.klaviyoListId || "").trim();
        const revision = (section.dataset.klaviyoRevision || "2026-04-15").trim();

        if (!companyId || !listId) return;

        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
            method: "POST",
            headers: {
                revision,
                "content-type": "application/json",
            },
            body: JSON.stringify(payload),
            keepalive: true,
        }).catch(() => {
            // Intentionally ignore: we don't want to block the native Shopify submit UX.
        });
    };

    const initSection = (section) => {
        if (!section) return;
        if (section.dataset.klaviyoFetchInitialized === "true") return;
        section.dataset.klaviyoFetchInitialized = "true";

        const enabled = (section.dataset.klaviyoEnabled || "").toString() === "true";
        if (!enabled) return;

        const form = section.querySelector("form.newsletter-form");
        if (!form) return;

        form.addEventListener("submit", () => {
            const formData = new FormData(form);
            const email = (formData.get("contact[email]") || "").toString().trim();
            const firstName = (formData.get("contact[first_name]") || "").toString().trim();
            const lastName = (formData.get("contact[last_name]") || "").toString().trim();

            subscribe(section, {
                data: {
                    type: "subscription",
                    attributes: {
                        profile: {
                            data: {
                                type: "profile",
                                attributes: {
                                    email,
                                    first_name: firstName,
                                    last_name: lastName,
                                },
                            },
                        },
                    },
                    relationships: {
                        list: {
                            data: {
                                type: "list",
                                id: (section.dataset.klaviyoListId || "").trim(),
                            },
                        },
                    },
                },
            });
        });
    };

    const initAll = () => {
        document.querySelectorAll(".newsletter").forEach(initSection);
    };

    document.addEventListener("DOMContentLoaded", initAll);
    document.addEventListener("shopify:section:load", (event) => {
        initSection(event.target.querySelector(".newsletter"));
    });
})();

